import { SummaryModel } from "src/app/modules/common/entity/summary.model";
import { PermissionsModel } from "src/app/modules/common/entity/permissions.model";
import {PartnerSummaryModel} from "../../../../../partner/common/api/model/partnerSummary.model";
import {Moment} from "moment";
import {UserSummary} from "../../../../../account/modules/user/api/entity/userSummary.model";
import {MEDICAL_TOOL_SET_LABEL} from "./medicalToolSet.model";
import {MedicalSterilizationSummaryModel} from "../../../sterilization/api/entity/medicalSterilizationSummary.model";

export class MedicalToolSetSummaryModel implements SummaryModel {
    id: number;
    permissions: PermissionsModel;
    businessIdentifier: string;
    useDate: Moment;
    partner: PartnerSummaryModel;
    validationDate: Moment;
    user: UserSummary;

    getLabel(sterilization: MedicalSterilizationSummaryModel) {
        let label =  MEDICAL_TOOL_SET_LABEL.replace('{{businessIdentifier}}', this.businessIdentifier);
        label = label.replace('{{responsible}}', sterilization.responsibleUser ? sterilization.responsibleUser.name : '/');
        label = label.replace('{{sterilizationDate}}', sterilization.sterilizationDate ? sterilization.sterilizationDate.format('DD/MM/yy') : '/');
        label = label.replace('{{validationDate}}', sterilization.validationDate ? sterilization.validationDate.format('DD/MM/yy') : '/');
        return label;
    }
}


